import { createAction } from '@reduxjs/toolkit';

export const SetSortFilterAction = createAction<string>('projectList/SetSortFilterAction');

export const SetKeywordFilterAction = createAction<string>('projectList/SetKeywordFilterAction');

export const SetOrderSortFilterAction = createAction<ProjectOrderSortFilter>('projectList/SetOrderSortFilterAction');

// Dispatched only by the dashboard's own filter dropdown - deliberately separate from
// SetOrderSortFilterAction, which other features (e.g. orderHistory) also dispatch for
// unrelated reasons and must not be able to mark as a deliberate dashboard choice.
export const MarkOrderSortFilterTouchedAction = createAction('projectList/MarkOrderSortFilterTouchedAction');

export const SetPageAction = createAction<number>('projectList/SetPage');

export const GetProjectsStartAction = createAction('projectList/GetProjectsStart');

export const GetProjectsSuccessAction = createAction<IProjectSuccess>('projectList/GetProjectsSuccess');

export const GetProjectsFailedAction = createAction<string>('projectList/GetProjectsFailed');

export const GetMapCoordinatesStartAction = createAction('projectList/GetMapCoordinatesStart');

export const GetMapCoordinatesSuccessAction = createAction<{ coordinates: IProjectMapCoordinate[]; missingLocationCount: number; requestKey?: string }>('projectList/GetMapCoordinatesSuccess');

export const GetMapCoordinatesFailedAction = createAction<string>('projectList/GetMapCoordinatesFailed');
export const MapCoordinatesFetchDroppedAction = createAction('projectList/MapCoordinatesFetchDropped');
export const InvalidateMapCoordinatesAction = createAction('projectList/InvalidateMapCoordinates');

export const SetShowMapviewAction = createAction<boolean>('projectList/SetShowMapviewAction');
export const SetEsriViewKindAction = createAction<EsriViewKind>('projectList/SetEsriViewKindAction');
export const SetSelectedPinProjectAction = createAction<string | null>('projectList/SetSelectedPinProjectAction');
export const SetPinGroupAction = createAction<{ ids: string[] }>('projectList/SetPinGroupAction');
export const SetMapFocusAction = createAction<{ kind: 'project'; id: string }>('projectList/SetMapFocusAction');
export const SetEsriCameraAction = createAction<{ kind: EsriViewKind; camera: IEsriCamera | null }>('projectList/SetEsriCameraAction');
export const SetRailViewAction = createAction<{ scrollTop: number; mountedCount: number } | null>('projectList/SetRailViewAction');

export const SetProjectsAction = createAction<any>('projectList/SetProjectsAction');

export const SetLoadAllAction = createAction<boolean>('projectList/SetLoadAllAction');

export const SetLoadNewAction = createAction<boolean>('projectList/SetLoadNewAction');

export const SetThumbnailAction = createAction<{ projectId: string, thumbnail: string }>('projectList/SetThumbnailAction');

export const DeleteProjectsStartAction = createAction<string>('projectList/DeleteProjectsStartAction');

export const DeleteProjectsSuccessAction = createAction<string>('projectList/DeleteProjectsSuccessAction');

export const DeleteProjectsFailedAction = createAction<string>('projectList/DeleteProjectsFailedAction');

export const UpdateProjectNameAction = createAction<IProject>('project/UpdateProjectNameAction');
export const UpdateProjectListTifFileAction = createAction<ITifFile>('projectList/UpdateProjectListTifFileAction');
export const UpdateProjectListLasFileAction = createAction<ILasFile>('projectList/UpdateProjectListLasFileAction');

export const DeleteProjectListTifFileAction = createAction<any>('projectList/DeleteProjectListTifFileAction');
export const DeleteProjectListLasFileAction = createAction<any>('projectList/DeleteProjectListLasFileAction');

export const UpdateProjectListImageryRequestSuccessAction = createAction<IImageryRequest>('projectList/UpdateProjectListImageryRequestSuccessAction');
